import {
  roles,
  paymentOfCreditCard,
  paymentOfOthers,
  billingPrintType,
  physicalProductOrderStatusTextTranslation,
  genderType,
  documentationType,
  supplierType,
  bookingClinicService,
  billingItemType,
  howToKnowType,
  productUnit,
  dayOfWeek,
  clientNotificationMessageType,
  clinicWorkspaces,
  doctorMedicalTermCategories,
  labReportType,
  billingItemCategory,
  labelLanguage,
  bookingStatus,
  bookingApprovalStatus,
  clinicMembership,
} from '@/data/constants';
import moment from 'moment';
import * as countryCodes from 'country-codes-list';

export const roleOptions = [
  {
    label: 'Admin',
    value: roles.admin,
  },
  {
    label: 'Member',
    value: roles.member,
  },
  {
    label: 'Doctor',
    value: roles.doctor,
  },
  {
    label: 'Clinic Staff',
    value: roles.clinicStaff,
  },
  {
    label: 'Clinic',
    value: roles.clinic,
  },
];

export const paymentOfCreditCardOptions = [
  {
    label: 'AE',
    value: paymentOfCreditCard.ae,
  },
  {
    label: 'Visa',
    value: paymentOfCreditCard.visa,
  },
  {
    label: 'Master',
    value: paymentOfCreditCard.master,
  },
];

export const paymentOfOthersOptions = [
  {
    label: 'Cash',
    value: paymentOfOthers.cash,
  },
  {
    label: 'Octopus Card',
    value: paymentOfOthers.octopusCard,
  },
  {
    label: 'Union Pay',
    value: paymentOfOthers.unionPay,
  },
  {
    label: 'Payme',
    value: paymentOfOthers.payMe,
  },
  {
    label: 'Paypal',
    value: paymentOfOthers.payPal,
  },
  {
    label: 'Alipay HK',
    value: paymentOfOthers.alipayHK,
  },
  {
    label: 'Bank Transfer',
    value: paymentOfOthers.bankTransfer,
  },
  {
    label: 'Cheque',
    value: paymentOfOthers.cheque,
  },
];

export const colorOption = [
  // Color Should Different
  { value: `ffffff`, label: 'Oil', description: `Oil` },
  { value: `f79433`, label: 'DO', description: `Dark Orange` },
  { value: `b41343`, label: 'DR', description: `Dark Red` },
  { value: `a96e46`, label: 'B', description: `Brown` },
  { value: `9a4724`, label: 'CO', description: `COCO` },
  { value: `974031`, label: 'CH', description: `Chestnut` },
  { value: `452e1f`, label: 'DB', description: `Dark Brown` },
  { value: `613b57`, label: 'DP', description: `Indigo` },
  { value: `811141`, label: 'RB', description: `Rose Brown` },
  { value: `c7c8ca`, label: 'HT', description: `Hair Mask` },
  { value: `8b0029`, label: 'WR', description: `Wine Red` },
  { value: `e2c321`, label: 'GO', description: `Gold` },
];
export const doseOption = [
  '0.5',
  '1',
  '1.5',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  // Color Should Different
];
export const durationOption = [
  '5',
  '10',
  '15',
  '20',
  '25',
  '30',
  '35',
  '40',
  '45',
  '50',
  '55',
  '60',
];

export const durationOption2 = [
  'Only 1 Round',
  '5',
  '10',
  '15',
  '20',
  '25',
  '30',
  '35',
  '40',
  '45',
  '50',
  '55',
  '60',
];

export const scalpSituationOption = [
  'Normal',
  'Hair Loss',
  'Sensitive / Red',
  'Dandruff',
  'Acne',
  'Itchy',
  'Eczema',
  'G6PD',
  'Other',
];
export const hairThicknessOption = [
  '銀離子染髮',
  'Red permanent dye / chinese dye',
  'Black permanent dye / chinese dye',
  'Chemical semi permanent',
  'Chemical light color',
  'Perm',
  'Other',
];
export const hairVolumeOption = ['Thick', 'Normal', 'Thin'];
export const hairConditionOption = [
  'Oily',
  'Normal',
  'Dry',
  'Frizzy',
  'Hair Loss',
  'Highlighted',
  'Chemical Dye',
  'Permed',
];
export const expectedColorResultOption = [
  'Dark Orange',
  'Dark Red',
  'Coco',
  'Chestnut',
  'Light Brown',
  'Dark Brown',
  'Black as possible',
  'Other',
];

export const bookingStatusOption = [
  { text: 'New Booking', value: bookingStatus.created },
  { text: 'Arrived', value: bookingStatus.arrived },
  { text: 'Absent', value: bookingStatus.absent },
  { text: 'Completed', value: bookingStatus.completed },
  { text: 'Cancelled', value: bookingStatus.cancelled },
  { text: 'Request Cancel', value: bookingStatus.requestCancel },
];

export const bookingApprovalStatusOptions = [
  { text: 'Pending', value: bookingApprovalStatus.pending },
  { text: 'Approved', value: bookingApprovalStatus.approved },
  { text: 'Unapproved', value: bookingApprovalStatus.unapproved },
];

export const districts = [
  'Central and Western',
  'Eastern',
  'Southern',
  'Wan Chai',
  'Kowloon City',
  'Kwun Tong',
  'Sham Shui Po',
  'Wong Tai Sin',
  'Yau Tsim Mong',
  'Islands',
  'Kwai Tsing',
  'North',
  'Sai Kung',
  'Sha Tin',
  'Tai Po',
  'Tsuen Wan',
  'Tuen Mun',
  'Yuen Long',
];

export const areas = ['Hong Kong', 'Kowloon', 'New Territories'];

export const month = [
  { text: 'January', value: '01' },
  { text: 'February', value: '02' },
  { text: 'March', value: '03' },
  { text: 'April', value: '04' },
  { text: 'May', value: '05' },
  { text: 'June', value: '06' },
  { text: 'July', value: '07' },
  { text: 'August', value: '08' },
  { text: 'September', value: '09' },
  { text: 'October', value: '10' },
  { text: 'November', value: '11' },
  { text: 'December', value: '12' },
];

export const years = Array.from({ length: 20 }, (_, i) => String(2022 + i));

export const bookingSortOption = [
  { value: { '_timetableTime.start': -1 }, label: 'By Service Time' },
  { value: { created_at: -1 }, label: 'By Booking Time' },
];

export const time = Array.from({ length: 48 }, (_, i) =>
  moment()
    .startOf('d')
    .add(i * 30, 'minutes')
    .format('HH:mm'),
);

export const leaveTypeOption = [
  { text: 'Sick Leave', value: 'SL' },
  { text: 'Annual Leave', value: 'AL' },
  { text: 'No Pay Leave', value: 'NPL' },
  { text: 'Compensatory Leave', value: 'CL' },
  { text: 'Other', value: 'Other' },
];

export const leaveApplicationStatusOption = [
  { value: '0$pending', label: 'Pending' },
  { value: '1$approved', label: 'Approved' },
  { value: '99$rejected', label: 'Rejected' },
];

export const physicalProductOrderStatusOption = [
  { value: '0$pendingPayment', text: physicalProductOrderStatusTextTranslation.pendingPayment },
  { value: '1$pendingDelivery', text: physicalProductOrderStatusTextTranslation.pendingDelivery },
  { value: '99$completed', text: physicalProductOrderStatusTextTranslation.completed },
  { value: '96$requestCancel', text: physicalProductOrderStatusTextTranslation.requestCancel },
  { value: '98$cancelled', text: physicalProductOrderStatusTextTranslation.cancelled },
  { value: '97$expired', text: physicalProductOrderStatusTextTranslation.expired },
];

export const physicalProductOrderPaymentStatusOption = [
  { text: 'Pending', value: 'pending' },
  { text: 'Paid', value: 'paid' },
  { text: 'Fail', value: 'fail' },
];

export const genderOption = [
  { text: 'Male', value: genderType.Male, icon: 'mdi-gender-male' },
  { text: 'Female', value: genderType.Female, icon: 'mdi-gender-female' },
  // { text: 'Other', value: genderType.Other, icon: 'mdi-heart-multiple' },
];

export const bloodTypeOption = ['A', 'B', 'AB', 'O'];

export const tagOption = ['AL', '@@', 'New', 'Day', 'Job', 'Guest', 'Test'];

export const onDutyDayOption = [
  { value: dayOfWeek.Monday, text: 'Monday' },
  { value: dayOfWeek.Tuesday, text: 'Tuesday' },
  { value: dayOfWeek.Wednesday, text: 'Wednesday' },
  { value: dayOfWeek.Thursday, text: 'Thursday' },
  { value: dayOfWeek.Friday, text: 'Friday' },
  { value: dayOfWeek.Saturday, text: 'Saturday' },
  { value: dayOfWeek.Sunday, text: 'Sunday' },
];

export const clinicServiceOption = [
  {
    text: 'Western Medical',
    value: bookingClinicService.westernMedicine,
  },
  {
    text: 'Chinese Medical',
    value: bookingClinicService.chineseMedical,
  },
  {
    text: 'Hospital Operation',
    value: bookingClinicService.hospitalOperation,
  },
  {
    text: 'ESD Life',
    value: bookingClinicService.esdLife,
  },
  {
    text: 'GEMVCare',
    value: bookingClinicService.gemvCare,
  },
];

export const medicinesOption = [
  {
    text: 'Western Medical',
    value: bookingClinicService.westernMedicine,
  },
  {
    text: 'Chinese Medical',
    value: bookingClinicService.chineseMedical,
  },
];

export const consultationResultTypeOption = [
  {
    text: 'Complaint',
    value: '0$complaint',
    medicalTermCategory: doctorMedicalTermCategories.complaint,
  },
  {
    text: 'Findings',
    value: '1$findings',
    medicalTermCategory: doctorMedicalTermCategories.findings,
  },
  {
    text: 'Diagnosis',
    value: '2$diagnosis',
    medicalTermCategory: doctorMedicalTermCategories.diagnosis,
  },
  {
    text: 'Action',
    value: '3$action',
    medicalTermCategory: doctorMedicalTermCategories.action,
  },
];

export const consultationFollowUpTimeIntervalOption = [
  {
    text: 'Next Week',
    value: [1, 'week'],
  },
  {
    text: 'After 2 Weeks',
    value: [2, 'week'],
  },
  {
    text: 'After 1 Month',
    value: [1, 'month'],
  },
  {
    text: 'After 2 Month',
    value: [2, 'month'],
  },
  {
    text: 'After 3 Month',
    value: [3, 'month'],
  },
  {
    text: 'After 6 Month',
    value: [6, 'month'],
  },
];

export const billingPrintOption = [
  {
    text: 'Print Address',
    value: billingPrintType.PrintAddress,
  },
  {
    text: 'Print Payment History',
    value: billingPrintType.PrintPaymentHistory,
  },
  {
    text: 'Print Bill Date',
    value: billingPrintType.PrintBillDate,
  },
  {
    text: 'Get Diagnosis',
    value: billingPrintType.GetDiagnosis,
  },
  {
    text: 'Patient Undersign',
    value: billingPrintType.PatientUndersign,
  },
  {
    text: 'Print Prescription',
    value: billingPrintType.PrintPrescription,
  },
  {
    text: 'Print Laboratory',
    value: billingPrintType.PrintLaboratory,
  },
  {
    text: 'Print Discount',
    value: billingPrintType.PrintDiscount,
  },
];

export const productUnitOption = Object.entries(productUnit).map(
  ([key, { text, text_chinese }]) => {
    return { text, text_chinese, value: key };
  },
);

export const medicamentItemGroupOption = ['藥粉', '祛痰劑', 'Canesten', 'Vag Tab'];

export const documentationTypeOption = [
  {
    text: 'Clinic USG',
    value: documentationType.ClinicUSG,
  },
  {
    text: 'Doctor Copy',
    value: documentationType.DoctorCopy,
  },
  {
    text: 'Medical Record',
    value: documentationType.MedicalRecord,
  },
  {
    text: 'Patient Copy',
    value: documentationType.PatientCopy,
  },
  {
    text: 'Others',
    value: documentationType.Others,
  },
  {
    text: 'Billing Record',
    value: documentationType.BillingRecord,
  },
];

export const supplierTypeOption = [
  {
    text: 'Laboratory',
    value: supplierType.laboratory,
  },
  {
    text: 'Pharma',
    value: supplierType.pharma,
  },
  {
    text: 'Courier',
    value: supplierType.courier,
  },
];

export const dragTypeOption = [
  { text: 'Liquid', value: 'Liquid' },
  { text: 'Tablet', value: 'Tablet' },
  { text: 'Capsules', value: 'Capsules' },
];
export const strengthUnitOption = [
  { text: 'mg', value: 'MG' },
  { text: 'g', value: 'G' },
];
export const defaultUsageDayOption = [{ text: 'X', value: 0 }, 1, 2, 3, 4, 5, 6, 7, 14, 30];

export const stockConditionOption = [
  { text: 'Less Then', value: 'Less Then' },
  // { text: 'Greater Then', value: 'Greater Then' },
  // { text: 'Equal', value: 'Equal' },
];

export const billingItemTypeOption = [
  { text: 'Western Medical', value: billingItemType.rml },
  { text: 'Chinese Medical', value: billingItemType.cm },
  // { text: 'CMHC', value: billingItemType.cmhc },
];

export const templateSizeOption = [
  { text: 'A4', value: 'A4' },
  { text: 'A5', value: 'A5' },
];
export const templateClinicOption = [
  { text: 'RML', value: '1$RML' },
  { text: 'CMHC', value: '2$CMHC' },
];

export const consultationDiscountOption = [
  { text: '10% off', value: 10 },
  { text: '15% off', value: 15 },
];

export const howToKnowOption = [
  { text: 'Seminar', value: howToKnowType.Seminar, cols: 3 },
  { text: 'Yahoo', value: howToKnowType.Yahoo, cols: 3 },
  { text: 'Google', value: howToKnowType.Google, cols: 3 },
  { text: 'Facebook', value: howToKnowType.Facebook, cols: 3 },
  {
    text: 'Newspapers / Magazines / Radio',
    value: howToKnowType.NewspapersMagazinesRadio,
    cols: 'auto',
  },
  { text: 'Friend’s referral', value: howToKnowType.FriendsReferral, cols: 7 },
  { text: 'Others', value: howToKnowType.Others, cols: 12 },
];

export const clientNotificationMessageTypeOption = [
  { text: 'Consultation Reminder', value: clientNotificationMessageType.Consultation },
  { text: 'Vaccination Reminder', value: clientNotificationMessageType.Vaccination },
  { text: 'Pre Blood Test Reminder', value: clientNotificationMessageType.BloodTest },
  { text: 'Custom Message', value: clientNotificationMessageType.Custom },
];

export const clinicWorkspacesOption = [
  { text: 'RML', value: clinicWorkspaces.RML },
  { text: 'CMHC', value: clinicWorkspaces.CMHC },
];

export const doctorMedicalTermCategoryOption = [
  { text: 'Diagnosis', value: doctorMedicalTermCategories.diagnosis },
  { text: 'Complaint', value: doctorMedicalTermCategories.complaint },
  { text: 'Findings', value: doctorMedicalTermCategories.findings },
  { text: 'Action', value: doctorMedicalTermCategories.action },
];

export const labReportTypeOption = [
  { text: 'Lab Items', value: labReportType.labItems },
  { text: 'Imaging Services', value: labReportType.imagingServices },
];

export const billingItemCategoryOption = [
  { text: 'Consultation', value: billingItemCategory.consultation },
  { text: 'Procedure', value: billingItemCategory.procedure },
  { text: 'Lab Items', value: billingItemCategory.labItems },
  { text: 'Imaging Services', value: billingItemCategory.imagingServices },
  { text: 'Medication', value: billingItemCategory.medication },
  { text: 'Ultrasound', value: billingItemCategory.ultrasound },
  { text: 'Other', value: billingItemCategory.other },
];

// export const countryCallingCodes = [
//   { text: '+86', value: '+86' },
//   { text: '+852', value: '+852' },
//   { text: '+853', value: '+853' },
// ];

export const countryCallingCodes = countryCodes
  .customArray({ countryCallingCode: '{countryCallingCode}', countryCode: '{countryCode}' })
  .map(({ countryCallingCode, countryCode }) => ({
    text: `+${countryCallingCode}`,
    value: `+${countryCallingCode}`,
  }));

export const labelLanguageOption = [
  { text: 'English', value: labelLanguage.en },
  { text: 'Chinese', value: labelLanguage.zhhk },
];

export const areaCodeOptions = [
  {
    text: '+44',
    value: +44,
    ISOCode: 'GB',
  },
  {
    text: '+60',
    value: +60,
    ISOCode: 'MY',
  },
  {
    text: '+61',
    value: +61,
    ISOCode: 'AU',
  },
  {
    text: '+852',
    value: +852,
    ISOCode: 'HK',
  },
  {
    text: '+853',
    value: +853,
    ISOCode: 'MO',
  },
  {
    text: '+86',
    value: +86,
    ISOCode: 'CN',
  },
  {
    text: '+886',
    value: +886,
    ISOCode: 'TW',
  },
];

export const membershipOptions = [
  { text: 'None', value: clinicMembership.default },
  { text: 'VIP', value: clinicMembership.vip },
];

export const DistrictsOptions = [
  {
    label: 'Central and Western District',
    value: 'Central and Western District',
    lat: 22.2855,
    long: 114.1577,
  },
  {
    label: 'Eastern District',
    value: 'Eastern District',
    lat: 22.2783,
    long: 114.2367,
  },
  {
    label: 'Southern District',
    value: 'Southern District',
    lat: 22.2461,
    long: 114.1626,
  },
  {
    label: 'Wan Chai District',
    value: 'Wan Chai District',
    lat: 22.2783,
    long: 114.1747,
  },
  {
    label: 'Kowloon City District',
    value: 'Kowloon City District',
    lat: 22.3193,
    long: 114.1954,
  },
  {
    label: 'Kwun Tong District',
    value: 'Kwun Tong District',
    lat: 22.3123,
    long: 114.2267,
  },
  {
    label: 'Sham Shui Po District',
    value: 'Sham Shui Po District',
    lat: 22.3307,
    long: 114.1628,
  },
  {
    label: 'Wong Tai Sin District',
    value: 'Wong Tai Sin District',
    lat: 22.3418,
    long: 114.1918,
  },
  {
    label: 'Yau Tsim Mong District',
    value: 'Yau Tsim Mong District',
    lat: 22.3053,
    long: 114.1694,
  },
  {
    label: 'Islands District',
    value: 'Islands District',
    lat: 22.2587,
    long: 113.9413,
  },
  {
    label: 'Kwai Tsing District',
    value: 'Kwai Tsing District',
    lat: 22.3573,
    long: 114.1276,
  },
  {
    label: 'North District',
    value: 'North District',
    lat: 22.4953,
    long: 114.1481,
  },
  {
    label: 'Sai Kung District',
    value: 'Sai Kung District',
    lat: 22.3814,
    long: 114.2719,
  },
  {
    label: 'Sha Tin District',
    value: 'Sha Tin District',
    lat: 22.3817,
    long: 114.1878,
  },
  {
    label: 'Tai Po District',
    value: 'Tai Po District',
    lat: 22.4507,
    long: 114.1714,
  },
  {
    label: 'Tsuen Wan District',
    value: 'Tsuen Wan District',
    lat: 22.3703,
    long: 114.1137,
  },
  {
    label: 'Tuen Mun District',
    value: 'Tuen Mun District',
    lat: 22.391,
    long: 113.9759,
  },
  {
    label: 'Yuen Long District',
    value: 'Yuen Long District',
    lat: 22.4461,
    long: 114.0178,
  },
];

export const ageRangesOption = [
  '0-10',
  '10-20',
  '20-30',
  '30-40',
  '40-50',
  '50-60',
  '60-70',
  '70-80',
  '80+',
];
